import _ from 'underscore';
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Icon } from '@fluentui/react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';

import { couponText } from './utils';
import { getCancelDialogContentStyles } from '../styles/cancel-dialog-content-styles';
import { DefaultCurrencyCode } from '../helpers';
import { CouponDetailsProps } from '../coupon-props';

export const CancelDialogContent = (props) => {
  const {
    couponDetails,
    couponPlatformText,
    descriptionText,
    getCouponCurrencyCode,
  } = props;

  const classes = useDefaultStyles(getCancelDialogContentStyles);
  const i18n = useContext(I18nContext);

  return (
    <div className="coupon-prompt-cancel-dialog-content">
      <div className={classNames(classes.contentDescription, 'content-description')}>
        {descriptionText || i18n.getString(_TL_('Run ads on the Microsoft Advertising Network to reach potential customers and direct them to your website.'))}
      </div>
      {couponDetails &&
        <div className={classNames(classes.couponContainer, 'coupon-container')}>
          <Icon
            className={classNames(classes.couponIcon, 'iconba-CouponSolid coupon-solid-icon')}
            iconName="CouponSolid"
            aria-hidden="true"
          />
          <div className={classNames(classes.couponContent, 'coupon-content')}>
            <div className={classNames(classes.couponText, 'coupon-text')}>
              {couponText({
                i18n,
                couponDetails,
                currencyCode: getCouponCurrencyCode(couponDetails.CurrencyId) || DefaultCurrencyCode,
              })}
            </div>
            <div className={classNames(classes.couponPlatform, 'coupon-platform')}>
              {couponPlatformText || i18n.getString(_TL_('This offer only applies to this account\'s ad spend and is valid across the Microsoft Advertising Network.'))}
            </div>
          </div>
        </div>
      }
    </div>
  );
};

CancelDialogContent.propTypes = {
  couponDetails: CouponDetailsProps,
  descriptionText: PropTypes.string,
  couponPlatformText: PropTypes.string,
  getCouponCurrencyCode: PropTypes.func,
};

CancelDialogContent.defaultProps = {
  couponDetails: null,
  descriptionText: undefined,
  couponPlatformText: undefined,
  getCouponCurrencyCode: _.noop,
};
